import React from "react";
import PropTypes from "prop-types";

const getTitle = (type) => {
  switch (type) {
    case "ADVANCED":
      return "Advanced Service";
    case "INTERACTIVE":
      return "Interactive Service";
    case "ABR":
      return "Area Based Routing Service";
    case "SIMPLE":
      return "Simple Service";
    default:
      return "Service";
  }
};

const readOnlyTag = (isPreview) => {
  if (isPreview) {
    return "";
  }
  return "- Read Only";
};

export const Header = (props) => (
  <div className="title">
    <h1>{`${getTitle(props.serviceType)} ${readOnlyTag(props.isPreview)}`}</h1>
  </div>
);

export default Header;

Header.propTypes = {
  serviceType: PropTypes.string,
  isPreview: PropTypes.bool,
};
